{
  "de": {
    "datatable": {
      "actions": {
        "add_filter": "Filter hinzufügen",
        "bulk_action": "Massenaktion",
        "bulk_edit": "Massenbearbeitung",
        "clear": "Leeren",
        "clear_filters": "Filter leeren",
        "collapse_all": "Alle einklappen",
        "collapse_row": "Zeile einklappen",
        "deselect_all": "Alle abwählen",
        "expand_all": "Alle ausklappen",
        "expand_row": "Zeile ausklappen",
        "filters": "Filter",
        "remove_filter": "Filter {label}: {value} entfernen",
        "select_all": "Alle auswählen",
        "select_row": "Zeile auswählen"
      },
      "import": {
        "error_row": "Zeile {row}",
        "errors_description": "Der Import wurde abgebrochen, da {count} Zeile(n) Fehler enthielten. Es wurden keine Datensätze importiert.",
        "errors_title": "Import fehlgeschlagen",
        "success": "Datei erfolgreich importiert",
        "title": "Import"
      },
      "labels": {
        "active_filters": "Aktive Filter",
        "columns_selected": "{count} Spalten ausgewählt",
        "freeze_columns": "Spalten fixieren",
        "freeze_rows": "Zeilen fixieren",
        "gridlines": "Rasterlinien",
        "group_by": "Gruppieren nach",
        "size": "Größe",
        "sticky_headers": "Fixierte Kopfzeilen",
        "striped_rows": "Gestreifte Zeilen",
        "toggle_columns": "Spalten ein-/ausblenden",
        "translation_mode_header": "Kopfzeile",
        "translation_mode_stacked": "Gestapelt",
        "translation_mode_toolbar": "Global",
        "translation_style": "Übersetzungsstil"
      }
    }
  }
}
